import { Value } from 'app/types-shared';

export interface ReportStatus {
  download?: any;
  contentType?: string;
  createdDate?: string;
  favourite?: Value;
  report?: Value;
  reportFileId?: number;
  status?: Value;
  description?: Value;
  emailed?: boolean;
  emailReceivers?: string;
  scheduled?: boolean;
  companyReport?: Value;
}

export interface DownloadReport {
  reportId: string;
  fetching: boolean;
}

export interface ReportsViewArea {
  reportStatus?: ReportStatus[];
  download?: DownloadReport;
  fetchingReportStatus?: boolean;
}

export interface ReportsViewState {
  reportsView?: ReportsViewArea;
}

export enum ReportFileStatus {
  waiting = 1,
  pending = 2,
  finished = 3,
  failed = 4
}
